import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { AuthContextType, User } from '../Types/UnitFeatureTypes';
import { useDispatch, useSelector } from 'react-redux';
import { user as currentUser, userIsLoading, userToken as currentUserToken } from '../Redux/selectors';
import { Actions } from '../Redux/Reducer/rootReducer';

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const user = useSelector(currentUser) as User;
  const isLoading = useSelector(userIsLoading);
  const userToken = useSelector(currentUserToken)
  const dispatch = useDispatch();
  
  const login = async (userData: FormData): Promise<boolean> => {
    await dispatch(Actions.fetchUser.userLoginAction.request({
      email: userData.get('email') as string,
      password: userData.get('password') as string,
    }));

    return userToken !== null;
  };

  const logout = (): void => {
    dispatch(Actions.fetchUser.logoutUser());
  };

  useEffect(() => {
    if (userToken && Object(user).length === 0) {
      dispatch(Actions.fetchUser.verifyUserTokenAction.request({ token: userToken }));
    }
  }, [userToken]);

  // useEffect(() => {
  //   const token = localStorage.getItem('token');
  //   if (token) {
  //     dispatch(Actions.fetchUser.verifyUserTokenAction.request({token}));
  //   }
  // }, []);
  
  const contextValue: AuthContextType = {
    user,
    isAuthenticated: user !== null && (!Array.isArray(user) || user.length > 0),
    isLoading,
    token: userToken,
    login,
    logout,
  };
  
  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthContextProvider');
  }
  return context;
};
